import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import documentUploadFormJson from '../../life-config/documentUploadConfig.json';
import apiUrlPoint from '../../life-config/apiEndPoints.json';
import { ApiService } from '../../services/api.service';
import { SharedApiService } from '../../services/shared-api.service';
import { DatePipe } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import trackingInfo from '../../life-config/journey-tracker.json';
import { SharedDataService } from '../../services/shared-data.service';

@Component({
    selector: 'app-upload-image',
    templateUrl: './upload-image.component.html',
    styleUrls: ['./upload-image.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class UploadImageComponent implements OnInit {

    reader: FileReader;

    imageURL1: string;
    imageURL2: string;
    imageURL3: string;
    proofList: any;
    apiUrl: object = apiUrlPoint.apiEndPoints;
    uuid: any;
    proposalId: any;
    // showCloseIcon = false;
    showSpinner = false;
    docIDProod: any;
    selectedDocumentId: any;
    selectedExpiryId: any;
    selectedDocId: number;
    tmpId: any;
    allDocumentData: any;
    proofTypeInfo: any;
    imageURL = [];
    picsToDisplay: any;
    documnetProofChange: any;
    fileList = [];
    isPhotoToDisplay = false;
    docListTyepInfo: any;
    isPdfFileExtension = false;
    updatedPhotoBlockInfo: any;
    autoPopulateDocFile = {};



    constructor(
        private apiService: ApiService,
        private datePipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private sharedData: SharedApiService,
        private snackBar: MatSnackBar,
        public sharedDataService: SharedDataService
    ) {


        this.activatedRoute.params.subscribe(params => {
            this.uuid = params['uuid'];
            this.proposalId = params['proposalId'];
        });

        this.sharedDataService.getProofDocumentData.subscribe(docRes => {

            if (docRes) {

                this.proofList = docRes;

            }
        });



        this.sharedDataService.sendDocumentType.subscribe(docTypeRes => {

            if (docTypeRes) {

                this.getDocumentDataInfo(docTypeRes);

            }
        });

        /**
         * get document response on upload data
         */

        this.sharedDataService.getSendSelectedData.subscribe(getSelectedResponse => {

            if (getSelectedResponse) {

                this.selectedDocId = getSelectedResponse;

            }
        });

        this.sharedDataService.getUploadDocData.subscribe(docResponse => {

            if (docResponse) {

                this.docIDProod = docResponse;
            }
        });

        this.sharedDataService.getSeletcedDocData.subscribe(docInfoResponse => {

            if (docInfoResponse) {

                this.selectedDocumentId = docInfoResponse;
            }
        });


        this.sharedDataService.getSendExpiryData.subscribe(selectedResponse => {

            if (selectedResponse) {

                this.selectedExpiryId = selectedResponse;
            }
        });


        this.sharedDataService.getChangeActivityInfo.subscribe(changeRes => {

            if (changeRes) {

                this.documnetProofChange = changeRes;
                this.getDocumentDataInfo();
            }
        });

        /**
         * getting data to create input fields to display img
         */
        this.sharedDataService.updatedPhotoBlockDisplayInfo.subscribe(res => {

            if (res && this.sharedDataService.apiAvails) {
                this.updatedPhotoBlockInfo = res;

                this.getSelectedDocumentTypeValue(this.sharedDataService.selectedDocumentType);

            }


        });

    }



    /**
     * Get Image and preview image
     */

    showImgPreview(event, idx) {

        this.fileList = [];
        const file = event.target.files[0];
        let files = event.target.files;
        const fileSize = Math.round(file.size / 1024);
        let returnedVal = true;
        let i = 0;

        /**
         * upload document restriction on uploading 2nd document withouth uploading 1st one
         */

        if (this.imageURL.length > 1) {
            i = i + 2;
        } else if (this.imageURL.length > 0) {
            i = i + 1;
        }

        if (idx > i) {
            const errMsg = 'Please upload other images before uploading this image';
            this.sharedDataService.setDocumentErrorMsg(errMsg);
            return;
        }

        /**
         * For photo proof - pdf will not be loaded
         */
        if (this.proofList && this.proofList['proofs'].length > 0) {

            this.proofList['proofs'].forEach(element => {

                if (element['proof_type'] === 0) {


                    if (file['type'] === 'application/pdf') {


                        this.snackBar.open('PDF file are not accpetable in photo proof. Please re-upload the image in .jpg, .jpeg format', '', {
                            duration: 2000
                        });

                        returnedVal = false;

                    }

                }

                return returnedVal;

            });

        }

        /**
         * End of photo proof that only jpg/ .jpeg accepted
         */


        if ((!(file['type']['match']('image/jpeg') || file['type']['match']('pdf.*'))) || (file.name.includes('.pjp') || file.name.includes('.pjpeg') || file.name.includes('.jfif'))) {

            // return  this.snackBar.open('invalid image');
            this.snackBar.open('.jpg, .JPEG are the acceptable Image formats. Please re-upload the image as per allowed formats', '', {
                duration: 2000
            });

            return;

        } else {

            if (fileSize > 5120) {
                // return this.snackBar.open('Cannot upload image  more than 5 MB');
                this.snackBar.open('Cannot upload image  more than 5 MB', '', {
                    duration: 5000
                });

                return;
            }

        }

        /**
         * updating image block on uploading document to fix pdf alignment issue
         */
        this.updatedPhotoBlockInfo.forEach((photoEle, index) => {

            let isPdfFileExtension;

            if (idx === index) {

                if (file['type'] === 'application/pdf') {
                    isPdfFileExtension = true;
                } else {
                    isPdfFileExtension = false;
                }

            } else {
                if (photoEle['isPdfFile']) {
                    isPdfFileExtension = true;
                } else {
                    isPdfFileExtension = false;
                }
            }

            photoEle['isPdfFile'] = isPdfFileExtension;

        });


        if (returnedVal) {

            this.reader = new FileReader();

            for (let file of files) {
                let reader = new FileReader();
                reader.onload = (e: any) => {
                    this.imageURL.push(e.target.result);

                }
                reader.readAsDataURL(file);
            }

            this.UploadService(file);

        }





    }

    /**
     * Service to upload
     */


    UploadService(file) {

        /**
         * Check for proof list
         */
        let proofData;
        let documentType;
        let docDataInfo = this.sharedDataService.docIDInfo;
        let expiryId = this.sharedDataService.expiryData;
        let expiryDate = this.sharedDataService.expiryDateInfo;

        if (this.proofList && this.proofList['proofs'].length > 0) {

            this.proofList['proofs'].forEach(element => {

                if (element['document_type'] === docDataInfo) {

                    // proofData = element['proof_type'];
                    this.proofTypeInfo = element['proof_type']
                    documentType = element['document_type'];

                    if (file) {
                        this.sharedDataService.setDocumnetDropdownDisable(true);
                    }

                }

                // handling proof type 0 (photo)
                if (element['proof_type'] === this.proofList['proofData']) {
                    // proofData =   this.proofList['proofData'];
                    this.proofTypeInfo = this.proofList['proofData'];
                    documentType = this.proofList['documentType'];

                }

            });

        }

        const postDocUrl = this.apiUrl['apiDocumentUpload'];
        const proposalId = this.proposalId;
        const uuid = this.uuid;
        const queryParamsURL = this.apiUrl['upload_doc'];
        const formData: any = new FormData();
        formData.append('document', file);
        formData.append('proof_type', this.proofTypeInfo);
        formData.append('doc_type', documentType);
        if (expiryId) {
            formData.append('doc_number', expiryId);
        }
        if (expiryDate) {
            formData.append('expiry_date', expiryDate);
        }

        this.apiService.postDocumentData(postDocUrl, proposalId, uuid, queryParamsURL, formData)
            .subscribe(res => {

                if (res) {
                    const response = JSON.stringify(res['docs']);

                    this.sharedDataService.getUploadedDocData(res['docs']);
                    this.sharedDataService.isUploadToNext(res['docs']);

                    /**
                     * Invoke submit button only when image has been uploaded
                     * then after that allow user to navigate
                     */


                    this.getDocumentDataInfo();
                }
                // localStorage.setItem('uploadData', JSON.stringify(res['docs']));
                // console.log("Inside upload Service", localStorage.getItem("uploadData"));
            },
                err => console.log(err),
            );


    }


    /**
     * Delete image on id rendering and user event scenario
     */

    deleteUploadService(returnedDocId, mainIndx) {
        this.showSpinner = true;
        let documentType;
        let proofType;
        let documentId;
        let proofInfo;
        let i = -1;
        const postDocUrl1 = this.apiUrl['apiDocumentUpload'];
        const proposalId1 = this.proposalId;
        const uuid1 = this.uuid;
        const queryParamsURL1 = this.apiUrl['fetch_docs'];

        // reset autopopulated document on delete button click
        // if (this.autoPopulateDocFile && Object.keys(this.autoPopulateDocFile).length > 0) {

        //     if (this.imageURL.length > 2) {
        //         i = i + 3;
        //     } else if (this.imageURL.length > 1) {
        //         i = i + 2;
        //     } else if (this.imageURL.length > 0) {
        //         i = i + 1;
        //     }

        //     if (mainIndx < i) {
        //         const errMsg = 'Please delete other images before deleting this image';
        //         this.sharedDataService.setDocumentErrorMsg(errMsg);
        //         this.showSpinner = false;
        //         return;
        //     } else {
        //         this.imageURL.splice(mainIndx, 1);
        //         this.showSpinner = false;
        //     }

        //     // enable document type field if no doc is uploaded
        //     if (this.imageURL.length === 0) {
        //         this.sharedDataService.setDocumnetDropdownDisable(false);
        //         this.autoPopulateDocFile = {};
        //         this.sharedDataService.isUploadToNext([]);
        //         this.sharedDataService.autoPopulateFinalData(this.autoPopulateDocFile);
        //     }

        // } else {
        this.apiService.getDocumentUploadedData(postDocUrl1, proposalId1, uuid1, queryParamsURL1)
            .subscribe((res: Response) => {

                // tslint:disable-next-line: forin
                const responseDataInfo: any = res['docs'];
                const postDocUrl = this.apiUrl['apiDocumentUpload'];
                const proposalId = this.proposalId;
                const uuid = this.uuid;
                const queryParamsURL = this.apiUrl['delete_doc'];


                /**
                 * for proof service - if proof list is coming then in that case
                 * extarct data and store the varibale
                 */

                if (typeof this.sharedDataService.proofTypeInfo === "number") {

                    proofInfo = this.sharedDataService.proofTypeInfo;

                } else {
                    const indexInfo = this.sharedDataService.proofIndex;
                    proofInfo = this.sharedDataService.proofTypeInfo[indexInfo]['proofs'][0]['proof_type'];


                }

                /**
                 * delet document restriction on deleting 1st document withouth deleting last docs
                 */
                if (this.imageURL.length > 2) {
                    i = i + 3;
                } else if (this.imageURL.length > 1) {
                    i = i + 2;
                } else if (this.imageURL.length > 0) {
                    i = i + 1;
                }

                if (mainIndx < i) {
                    if (this.autoPopulateDocFile && Object.keys(this.autoPopulateDocFile).length === 0) {
                        const errMsg = 'Please delete other images before deleting this image';
                        this.sharedDataService.setDocumentErrorMsg(errMsg);
                        this.showSpinner = false;
                        return;
                    }
                }


                /**
                 * Extracting document data
                 * proof_type , document_type and document_id
                 * this will be activated only when uplod service are being triggered
                 * case 2 :- if DocId proof is undefined then utilised get response data
                 * and  extarct data from proof type
                 */


                // if (this.docIDProod && this.docIDProod.length > 0) {

                //     this.docIDProod.filter((element, index) => {

                //         if (element['proof_type'] === proofInfo) {

                //             documentType = element['doc_type'];
                //             proofType = element['proof_type'];
                //             documentId = element['id'];

                //         }

                //     });

                // } else {
                responseDataInfo.filter((element, index) => {

                    if (element['proof_type'] === proofInfo) {

                        if (this.imageURL[mainIndx] === element['doc_url']) {
                            documentType = element['doc_type'];
                            proofType = element['proof_type'];
                            documentId = element['id'];
                        }

                    }

                });
                // }

                this.showSpinner = true;

                if (documentType && documentId) {

                    this.apiService.deleteDocumentData(postDocUrl, proposalId, uuid, queryParamsURL, documentType, proofType, documentId)
                        .subscribe((res: any) => {

                            this.updatedPhotoBlockInfo = [];
                            this.getDocumentDataInfo();
                            this.showSpinner = false;
                            this.sharedDataService.getUploadedDocData(res['docs']);
                            // this.imageURL = '';
                            // this.showCloseIcon = false;

                            this.sharedDataService.setDocumnetDropdownDisable(false);

                        },
                            err => this.showSpinner = false
                        );
                }

            });
        // }


    }


    /**
     * Add this in shared services so that rendering can be done from there
     */
    getDocumentDataInfo(docInfoType?: any) {

        this.imageURL = [];
        this.autoPopulateDocFile = {};
        const postDocUrl = this.apiUrl['apiDocumentUpload'];
        const proposalId = this.proposalId;
        const uuid = this.uuid;
        const queryParamsURL = this.apiUrl['fetch_docs'];

        let indexUrlInfo: any = this.sharedDataService.proofIndex;




        this.apiService.getDocumentUploadedData(postDocUrl, proposalId, uuid, queryParamsURL)
            .subscribe(res => {

                if (res['docs']) {

                    this.allDocumentData = res['docs'];
                    this.sharedDataService.isUploadToNext(res['docs']);
                    this.reader = new FileReader();
                    let i = 1;


                    if (this.allDocumentData && this.allDocumentData.length > 0) {


                        if (this.sharedDataService.proofDataList && this.sharedDataService.proofDataList.length > 0) {

                            /**
                             * proof obtained from list should be equal to api obatined proof
                             * then update index on the bass of proof by shared data
                             */

                            this.allDocumentData.forEach((element, index) => {


                                if ((this.sharedDataService.proofDataList[this.sharedDataService.proofIndex]['proofs'][0]['proof_type'] === element['proof_type'])) {

                                    this.imageURL.push(element['doc_url']);

                                    this.sharedDataService.sendDocumentInfo(element);

                                } else {
                                    this.updatedPhotoBlockInfo = this.sharedDataService.photosToDsiplay;
                                }

                            });

                            /**
                             * pdf doc handling
                             */
                            this.documentBlockUpdation();

                            this.showSpinner = false;
                            this.isPhotoToDisplay = true;

                        }




                    }


                } else {
                    this.showSpinner = false;
                    // this.showCloseIcon = false;
                    this.isPhotoToDisplay = false;

                    /**
                     * handling of only photo doc is uploaded and deleted that doc then img field is getting hide
                     */
                    this.updatedPhotoBlockInfo = this.sharedDataService.photosToDsiplay;
                }


            },
                err => console.log(err),
            );


    }


    getCSSClasses() {
        let cssClasses;
        if (this.imageURL) {
            cssClasses = {
                indexImg: true
            };
        } else {
            cssClasses = {
                indexImg: false
            };
        }
        return cssClasses;
    }

    /**
     * handling of block to display to handle pdf document
     */
    documentBlockUpdation() {

        if (this.imageURL && this.imageURL.length > 0) {

            this.updatedPhotoBlockInfo = this.sharedDataService.photosToDsiplay;

            this.sharedDataService.photosToDsiplay.forEach((photoEle, index) => {

                this.imageURL.forEach((element, imgIndex) => {

                    if (imgIndex === index) {

                        const fileExtension = element.split('.').pop();

                        if (fileExtension === 'pdf') {
                            this.updatedPhotoBlockInfo[imgIndex]['isPdfFile'] = true;
                        } else {
                            this.updatedPhotoBlockInfo[imgIndex]['isPdfFile'] = false;
                        }

                    }

                });

            });

        }
    }

    /**
     * auto populate document if document type same as previous proof type
     */

    getSelectedDocumentTypeValue(obtainerDocVal) {

        this.imageURL = [];
        this.autoPopulateDocFile = {};

        if (this.allDocumentData && this.allDocumentData.length > 0) {

            let proofData;

            // getting value of selected proof type

            if (this.proofList && this.proofList['proofs'].length > 0) {

                this.proofList['proofs'].forEach(element => {

                    if (element['document_type'] === obtainerDocVal) {

                        proofData = element['proof_type'];

                    }

                });

            }

            /**
             * document type obtained from list should be equal to api obatined doc type
             */

            this.allDocumentData.find(element => {

                if (element['doc_type'] === obtainerDocVal) {

                    if (this.imageURL.length !== this.sharedDataService.photosToDsiplay.length) {

                        this.imageURL.push(element['doc_url']);
                    }

                }

            });

            /**
             * json data post api call on submit button
             */

            if (this.imageURL && this.imageURL.length > 0) {

                this.documentBlockUpdation();

                const docData = {
                    "proof_type": proofData,
                    "doc_type": obtainerDocVal,
                    "doc_url": this.imageURL
                }

                const finalData = [];
                finalData.push(docData);

                this.autoPopulateDocFile = finalData;

                if (docData) {
                    this.sharedDataService.isUploadToNext(finalData);

                    this.sharedDataService.autoPopulateFinalData(docData);
                }

            }

        }

    }

    ngOnInit() {
        this.getDocumentDataInfo();
        this.updatedPhotoBlockInfo = this.sharedDataService.photosToDsiplay;
    }

}
